import { Deserializer } from "jsonapi-serializer";
import RequestService from "../RequestService";
import RequestInitializer from '../RequestInitializer';

export default class PiratesService
{
  static initialize(){
    const [request] = RequestInitializer.get(1);
    const { source, get } = request;

    return {
      source,
      get: async (params, deserialize = true) => {
        const [response] = await get("/pirates", params);
        return PiratesService.deserialize(response, deserialize);
      }
    }
  };

  static async get(params, deserialize = true){
    const [response] = await RequestService.get("/pirates", params);
    return PiratesService.deserialize(response, deserialize);
  }

  static async deserialize(response, deserialize = true){
    if (response) {
      if(!deserialize) return response;

      const pirates = await new Deserializer({
        id: "id",
        keyForAttribute: "camelCase",
        typeAsAttribute: false,
      }).deserialize(response);
      
      return [pirates, response.links];
    }

    return [];
  }
}